/**
 * Help — the user guide, rendered from public/guide.md.
 *
 * The same file is served as-is at /guide.md (and listed in /llms.txt) so an
 * AI agent can read it as plain text. Editing that one file updates both.
 *
 * This page is also reachable signed out (see main.tsx): an agent, or a person
 * about to sign in, should be able to read how the app works first. The guide
 * holds no household data.
 */
import guide from '../../public/guide.md?raw';
import { Markdown, headings } from '../markdown.js';

export function Guide() {
  const toc = headings(guide);
  // Contents go after the title and intro, which end at the first rule.
  const split = guide.indexOf('\n---\n');
  const intro = split === -1 ? '' : guide.slice(0, split);
  const body = split === -1 ? guide : guide.slice(split);
  return (
    <article className="guide">
      <Markdown source={intro} />
      <nav className="card guide-toc" aria-label="Contents">
        <strong className="small">On this page</strong>
        <ul className="small">
          {toc.map((h) => (
            <li key={h.id}>
              <a href={`#${h.id}`}>{h.text}</a>
            </li>
          ))}
        </ul>
        <p className="xs muted">
          Plain-text copy for AI agents: <a href="/guide.md">/guide.md</a>
        </p>
      </nav>
      <Markdown source={body} />
    </article>
  );
}
